import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { Building2, Users, FilePlus2, Send, ShieldCheck, Route } from "lucide-react";

const STEPS = [
  { n: "01", icon: Building2, title: "Create Your Broker Account", copy: "Set up the brokerage and authorized team." },
  { n: "02", icon: Users, title: "Build Your Driver Network", copy: "Invite drivers you already know and connect with eligible drivers on RelayRigs." },
  { n: "03", icon: FilePlus2, title: "Create a Load or Opportunity", copy: "Enter route, equipment, pickup, delivery, compensation, and requirements." },
  { n: "04", icon: Send, title: "Choose Who Receives It", copy: "Send privately to one driver, several drivers, a driver group, or other configured eligible participants." },
  { n: "05", icon: ShieldCheck, title: "Complete Required Authorization", copy: "Where applicable, the responsible motor carrier and required compliance processes determine whether the driver is authorized and cleared to operate." },
  { n: "06", icon: Route, title: "Track the Assignment", copy: "Follow pickup, trip progress, delivery, documentation, service records, and billing from RelayRigs." },
];

export const BrokerHowItWorks = () => (
  <section data-testid="broker-how-it-works-section" className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="How It Works" title="From Driver Network to Tracked Assignment." testId="broker-how-it-works" />
      <RevealStagger className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {STEPS.map((step) => (
          <RevealItem key={step.n}>
            <div data-testid={`broker-how-it-works-step-${step.n}`} className="relative bg-rr-surface rounded-2xl p-6 h-full border border-rr-line hover:border-rr-orange/50 hover:-translate-y-1 transition-all">
              <span className="absolute right-5 top-5 font-heading text-4xl font-black text-rr-navy/[0.07]">{step.n}</span>
              <div className="w-12 h-12 rounded-xl bg-rr-orange/10 text-rr-orange flex items-center justify-center mb-5">
                <step.icon size={22} />
              </div>
              <h3 className="font-heading font-bold text-lg text-rr-navy">{step.title}</h3>
              <p className="text-sm text-rr-muted mt-2 leading-relaxed">{step.copy}</p>
            </div>
          </RevealItem>
        ))}
      </RevealStagger>
    </div>
  </section>
);
